import { Box, Typography } from '@mui/material';
import { ThumbnailView } from 'components/atoms';

import { AddToPatientProfileHeaderProps } from './types';

export const AddToPatientProfileHeader = ({
  title,
  imageUrl,
}: AddToPatientProfileHeaderProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'start' }}>
      <ThumbnailView
        fullImageUrl={imageUrl}
        rowView={true}
        imageStyle={{ maxHeight: '150px' }}
      />
      <Typography gutterBottom variant={'h5'} sx={{ marginY: 'auto', textAlign: 'left' }}>
        {title}
      </Typography>
    </Box>
  );
};
